<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-opacity-75 bg-black" @click="update({ modalCountries: false })" v-if="modalCountries">
    <div class="relative rounded flex max-h-full flex-col overflow-hidden bg-gray-300 text-black" style="height: 90%" @click.stop>
      <div class="z-20 flex divide-x divide-gray-700 divide-opacity-25 bg-gray-800 text-white text-center">
        <div class="flex-1 flex flex-col space-y-2 items-center justify-center flex-shrink-0 border-none">
          <div class="font-bold">Country</div>
          <div class="flex justify-between text-xs text-gray-500" title="Players with flags">{{ countryPlayers.length }} / {{ players.length }} ({{ countryPercent }}%)</div>
        </div>
        <div class="w-24 sm:w-32 flex-col py-1 justify-center cursor-pointer" v-for="mode in activeModes" :key="mode.id" @click.stop="localSort = `${mode.id}.rating`">
          <div class="mode p-1 text-sm font-bold uppercase" :class="getSortClass(mode.id)" :title="mode.title">{{ mode.name }}</div>
          <div class="flex flex-col sm:flex-row justify-between text-xs text-gray-500">
            <div class="px-2 py-1 hover:text-white" :class="getSortClass(`${mode.id}.placement`)" title="sum(501 - player_placement)" @click.stop="localSort = `${mode.id}.placement`">Placement</div>
            <div class="px-2 py-1 hover:text-white" :class="getSortClass(`${mode.id}.rating`)" title="sum(player_rating - min_rating + 1)" @click.stop="localSort = `${mode.id}.rating`">Rating</div>
          </div>
          <div class="flex flex-col sm:flex-row justify-between text-xs text-gray-500">
            <div class="px-2 py-1 hover:text-white" :class="getSortClass(`${mode.id}.matches`)" title="sum(player_matches)" @click.stop="localSort = `${mode.id}.matches`">Matches</div>
            <div class="px-2 py-1 hover:text-white" :class="getSortClass(`${mode.id}.players`)" title="count(players)" @click.stop="localSort = `${mode.id}.players`">Players</div>
          </div>
        </div>
        <div class="w-2 border-none"></div>
      </div>
      <div class="flex-1 overflow-x-hidden overflow-y-scroll">
        <div class="row flex items-stretch divide-x divide-gray-500 divide-opacity-25" v-for="(country, index) in sortedCountries" :key="country.name">
          <div class="w-10 flex items-center justify-center text-sm flex-shrink-0">{{ index + 1 }}</div>
          <div class="w-24 sm:w-32 flex items-center justify-between p-2 font-bold">
            <div class="flex-1">
              <i class="flex-shrink-0 rounded-sm flag-icon bg-gray-400" :class="`flag-icon-${country.name}`" :title="country.name" />
              {{ country.name }}
            </div>
            <div class=" text-gray-500" :title="`Players from ${country.name.toUpperCase()}`">
              {{ country.players.length }}
            </div>
          </div>
          <div class="w-24 sm:w-32 rating flex items-center justify-center p-2 flex-shrink-0 font-bold" :class="mode.id" v-for="mode in activeModes" :key="mode.id">
            <template v-if="country[mode.id]">
              <div class="w-full flex flex-wrap items-center" :class="{ 'justify-center': sortField === 'players' }">
                {{ country[mode.id][sortField] }}
                <small class="w-full font-normal text-gray-600" v-show="sortField === 'matches'">{{ country[mode.id].avgMatches }} avg<!--({{ country[mode.id].winrate }}% wins)--></small>
                <small class="w-full font-normal text-gray-600" v-show="sortField === 'placement'">{{ country[mode.id].avgPlacement }} avg</small>
                <small class="w-full font-normal text-gray-600" v-show="sortField === 'rating'">{{ country[mode.id].avgRating }} avg</small>
              </div>
              <div class="text-gray-500" :title="`${mode.name} players from ${country.name.toUpperCase()}`" v-if="sortField !== 'players'">
                {{ country[mode.id].players }}
              </div>
            </template>
            <small class="w-full h-full flex items-center justify-center text-gray-500" title="No rating or out of Top-500" v-else>—</small>
          </div>
        </div>
      </div>
      <!-- <div class="absolute top-0 right-0 m-2 mr-4 p-1 cursor-pointer text-2xl text-gray-500 hover:text-red-600" @click="update({ modalCountries: false })">✖</div> -->
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  export default {
    name: 'LeaderboardCountries',
    data() {
      return {
        localSort: 'md_duel.rating',
        success: false,
        error: null,
      }
    },
    computed: {
      ...mapState(['modalCountries', 'players']),
      ...mapGetters(['countries', 'modes', 'sort']),
      activeModes() {
        return this.modes.slice(0, 5)
      },
      countryPlayers() {
        return this.players.filter(player => player.country)
      },
      countryPercent() {
        return Math.round((100 * this.countryPlayers.length) / this.players.length)
      },
      sortedCountries() {
        const [mode, field] = this.localSort.split('.')
        const countries = this.countries.concat()

        countries.sort((player1, player2) => {
          const value1 = (player1[mode] && player1[mode][field]) || -1
          const value2 = (player2[mode] && player2[mode][field]) || -1
          return value1 > value2 ? -1 : value1 < value2 ? 1 : 0
        })

        return countries
      },
      sortMode() {
        return this.localSort.split('.')[0]
      },
      sortField() {
        return this.localSort.split('.')[1]
      },
      sortModeName() {
        return this.modes.find(mode => mode.id === this.sortMode).name
      },
      sortFieldName() {
        return this.sortField.substr(0, 1).toUpperCase() + this.sortField.substr(1)
      },
    },
    watch: {
      modalCountries(isVisible) {
        if (isVisible) {
          this.localSort = `${this.sort}`
        }
      },
    },
    methods: {
      ...mapActions(['update']),
      getSortClass(sort) {
        const [mode, field] = sort.split('.')
        return {
          active: field ? this.localSort === sort : this.localSort.includes(mode),
        }
      },
    },
  }
</script>

<style scoped>
  .active {
    color: #f6e05e !important;
  }
  ::-webkit-scrollbar {
    background-color: rgba(0, 0, 0, 0.1);
    width: 0.5rem;
  }
  ::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
  }
  ::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.3);
  }
</style>
